module.exports = __webpack_public_path__ + "img/item3.7ef1ac0c.png";